import EditIcon from '@/common/assets/icons/editIcon.svg?react';
import SmsOtpIcon from '@/common/assets/icons/smsOtpIcon.svg?react';
import CallOtpIcon from '@/common/assets/icons/callOtpIcon.svg?react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';
import LoginImage from '@/modules/Auth/assets/icons/loginIcon.svg?react';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import useValidateOtpRequest from '@/modules/Auth/hooks/useValidateOtpRequest.ts';
import { Box, Center, Flex } from 'styled-system/jsx';
import { css } from 'styled-system/css';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import OtpInput from '@/common/components/base/input/otp/OtpInput.tsx';
import FixToBottom from '@/common/components/layouts/FixToBottom.tsx';
import LoadingButton from '@/common/components/base/button/loadingButton.tsx';
import useCountDown from '@/modules/Auth/hooks/useCountDown.ts';
import useCreateVoiceOtp from '@/modules/Auth/hooks/useCreateVoiceOtp.ts';
import useSignInRequest from '@/modules/Auth/hooks/useSignInRequest.ts';
import { LoginFormDataType } from '@/modules/Auth/types/formDataType/loginFormData.type.ts';
import Button from '@/common/components/base/button/Button';
import { useNavigate } from 'react-router-dom';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS';

export default function () {
  return (
    <MainLayout header="onlyBackHeader" title="ورود">
      <LoginOtp />
    </MainLayout>
  );
}

const LoginOtp = () => {
  const [disableSubmit, setDisableSubmit] = useState(true);
  const { handleSubmit, getValues } = useFormContext<LoginFormDataType>();
  const { mutate: validateOtpMutate, isPending } = useValidateOtpRequest();
  const navigate = useNavigate();
  const onSubmitOtp: SubmitHandler<LoginFormDataType> = ({
    phone_number,
    code,
  }) => {
    validateOtpMutate({
      phone_number,
      code: code,
    });
  };
  const otpInputOnchange = (_value: string, completed: boolean) => {
    setDisableSubmit(!completed);
    if (completed) {
      handleSubmit(onSubmitOtp)();
    }
  };
  return (
    <Box>
      <Center my="20px">
        <LoginImage />
      </Center>
      <form
        onSubmit={handleSubmit(onSubmitOtp)}
        className={css({ width: '100%' })}
      >
        <TitleDescription mb="10px" textStyle="b1" color="black-1">
          کد تایید، به شماره ی ثبت شده ارسال شد.
        </TitleDescription>

        <Flex gap="10px" alignItems="center" width="100%">
          <Button
            p={0}
            variant="text"
            height="initial"
            onClick={() => {
              navigate(AUTH_LINKS.login, { replace: true });
            }}
          >
            <EditIcon
              className={css({
                stroke: 'black-2',
              })}
            />
          </Button>
          <Typography textStyle="b1" color="black-1">
            {getValues('phone_number')}
          </Typography>
        </Flex>
        <OtpInput onChange={otpInputOnchange} name="code" />
        <TimerCountdown />
        <FixToBottom>
          <LoadingButton loading={isPending} disabled={disableSubmit} fullWidth>
            ادامه
          </LoadingButton>
        </FixToBottom>
      </form>
    </Box>
  );
};

const TimerCountdown = () => {
  const { startTimer, minuteTimer, isCounterFinished } = useCountDown(120);
  const { mutate: createVoiceOtpMutate } = useCreateVoiceOtp();
  const { mutate: createSmsOtpMutate } = useSignInRequest();
  const { getValues } = useFormContext();
  const resendVoiceOtpCode = () => {
    createVoiceOtpMutate(
      { phone_number: getValues('phone_number') },
      { onSuccess: startTimer },
    );
  };
  const resendOtpCode = () => {
    createSmsOtpMutate(
      { phone_number: getValues('phone_number') },
      {
        onSuccess: startTimer,
      },
    );
  };

  useEffect(() => {
    startTimer();
  }, []);

  if (isCounterFinished) {
    return (
      <Flex flexDir="column" gap="1rem">
        <Typography textStyle="b4" color="black-2">
          آیا کد تأیید را دریافت نکرده‌اید؟ جهت ارسال مجدد کد اقدام نمایید.
        </Typography>
        <Flex onClick={resendOtpCode} gap="5px" alignItems="center">
          <SmsOtpIcon
            className={css({
              stroke: 'purple-3',
            })}
          />
          <Typography textStyle="b2" color="purple-2">
            ارسال از طریق پیامک
          </Typography>
        </Flex>
        <Flex onClick={resendVoiceOtpCode} gap="5px" alignItems="center">
          <CallOtpIcon
            className={css({
              stroke: 'purple-3',
            })}
          />
          <Typography textStyle="b2" color="purple-2">
            دریافت از طریق تماس تلفنی
          </Typography>
        </Flex>
      </Flex>
    );
  }
  return (
    <Center marginTop="80px" gap="5px">
      <Typography textStyle="b2" color="purple-2">
        {minuteTimer}
      </Typography>
      <Typography textStyle="b2" color="gray">
        ارسال مجدد کد
      </Typography>
    </Center>
  );
};
